import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	NTH_USER_AUTO_FOLLOW_SPACES,
	NTH_USER_AUTO_FOLLOW_TEAMMATES,
} from '../../constants/onboarding-state/onboarding-constants.ts';
import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadAutoFollowTeammatesState = () => {
	return waitForAllReturnWhenError([
		query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: getOnboardingStateGQL,
			variables: {
				key: [
					NTH_USER_AUTO_FOLLOW_SPACES.HAS_AUTO_FOLLOWED_SPACES,
					NTH_USER_AUTO_FOLLOW_SPACES.HAS_AUTO_FOLLOWED_SPACES_V2,
					NTH_USER_AUTO_FOLLOW_TEAMMATES.HAS_AUTO_FOLLOWED_TEAMMATES,
					NTH_USER_AUTO_FOLLOW_TEAMMATES.AUTO_FOLLOW_BANNER_DISMISSED,
					NTH_USER_AUTO_FOLLOW_TEAMMATES.AUTO_FOLLOW_BANNER_SHOWN_AT,
				],
			},
		}),
	]);
};
